import axios from 'axios';

// ACTION
export const DOCUMENTS = {
    GET_DOCUMENTS: 'GET_DOCUMENTS',
};

// ACTION CREATORS
export const getDocuments = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_SITE}/documents`);

            if (data.success) {
                const documents = data.data || [];

                dispatch({
                    type: DOCUMENTS.GET_DOCUMENTS,
                    documents,
                });
            }
        } catch (e) {
            console.log(e);
        }
    };
};

